import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=c7fac578&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=c7fac578&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fac578",
  null
  
)

export default component.exports